import { marked } from 'marked';
import { write } from '../language/lang.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { html } from 'lit';

export function convertToMarkdown(
  data: string | string[] | undefined | null,
  trimBlanks = true
): string {
  if (!data) return '';

  if (trimBlanks) {
    const newdata = typeof data === 'string' ? data.split('\n') : data;
    data = newdata
      .map((line) => {
        let newLine = line.trimStart();
        while (newLine.trimStart().startsWith('++')) {
          newLine = newLine.replace('++', '  +');
        }

        return newLine;
      })
      .join('\n');
  } else {
    data = typeof data === 'string' ? data : data.join('\n');
  }
  return marked.parse(data, { async: false });
}

export function convertToMarkdownHTML(
  data: string | string[] | undefined | null,
  trimBlanks = true
) {
  return unsafeHTML(convertToMarkdown(data, trimBlanks));
}

export function convertToMarkdownTemplateResult(
  data: string | string[] | undefined | null,
  trimBlanks = true
) {
  return html`${unsafeHTML(convertToMarkdown(data, trimBlanks))}`;
}

export function formatStringsAsMarkdownList(data: string[] | null | undefined) {
  return (data ?? []).map((x) => `+ ${x}`).join('\n');
}

export function writeMdHTML(
  template: TemplateStringsArray,
  ...args: unknown[]
) {
  const data = write(template, ...args);
  return convertToMarkdownHTML(data);
}

export function writeMdTemplate(
  template: TemplateStringsArray,
  ...args: unknown[]
) {
  const data = write(template, ...args);
  return convertToMarkdownTemplateResult(data);
}
